const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  typography: {
    fontSize: 20,
  },
}

export default config
